(function(){
  if (window.__dynBadgesInit) return;
  window.__dynBadgesInit = true;
  var ROTATE_MS = 2800;
  function init(el){
    if (el.dataset.dynBadgesInit) return;
    el.dataset.dynBadgesInit = '1';
    var track = el.querySelector('.dyn-badges-track');
    if (!track) return;
    var badges = track.querySelectorAll('.dyn-badge');
    if (badges.length <= 1) return;
    var h = badges[0].offsetHeight || 22;
    var i = 0;
    var paused = false;
    el.addEventListener('mouseenter', function(){ paused = true; });
    el.addEventListener('mouseleave', function(){ paused = false; });
    setInterval(function(){
      if (paused) return;
      i = (i + 1) % badges.length;
      track.style.transform = 'translateY(-' + (i * h) + 'px)';
    }, ROTATE_MS);
  }
  function initAll(){ document.querySelectorAll('.dyn-badges').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  var obs = new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('dyn-badges')) init(node);
        if (node.querySelectorAll) node.querySelectorAll('.dyn-badges').forEach(init);
      });
    });
  });
  obs.observe(document.body, {childList:true, subtree:true});
})();
